"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = verifyRecaptchaToken;
const axios_1 = __importDefault(require("axios"));
const constants_1 = require("../constants");
const RECAPTCHA_API = 'https://www.google.com/recaptcha/api/siteverify';
/**
 * This function generates a middleware that can verify recaptcha tokens
 * passed as headers using the given recaptcha secret
 * @param recaptchaSecret
 */
function verifyRecaptchaToken(recaptchaSecret) {
    return async function verifyRecaptchaTokenMiddleware(req, res, next) {
        const token = req.headers[constants_1.RequestHeaders.ReCAPTCHAToken];
        // This API only accepts application/x-www-form-urlencoded
        // https://groups.google.com/g/recaptcha/c/yEPN3d9ylT8/m/sisDSTBFDAAJ
        const result = await axios_1.default.post(RECAPTCHA_API, `secret=${recaptchaSecret}&response=${token}`, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        });
        if (result.status === 200 && result.data.success === true) {
            next();
        }
        else {
            res.status(403).json({
                error: 'recaptcha.invalid',
            });
        }
    };
}
